var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { AbstractRepository } from 'packages/core/AbstractRepository';
import { injectable } from 'tsyringe';
import { MolPresets } from 'packages/old_mol/entities/MolPresets';
import { EntityBuilder } from '@decahedron/entity';
var MolFormPresetsRepository = /** @class */ (function (_super) {
    __extends(MolFormPresetsRepository, _super);
    function MolFormPresetsRepository() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.entity = MolPresets;
        _this.url = 'api/v2/jobs/mol/presets';
        return _this;
    }
    MolFormPresetsRepository.prototype.getPresets = function () {
        var _this = this;
        return this.get(this.url)
            .then(function (response) { return EntityBuilder.buildOne(MolPresets, _this.responseTransformer(response).data); });
    };
    MolFormPresetsRepository = __decorate([
        injectable()
    ], MolFormPresetsRepository);
    return MolFormPresetsRepository;
}(AbstractRepository));
export { MolFormPresetsRepository };
